import { ApplicationRef, DoBootstrap } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { CustomElementDefinition, CustomElementDefinitions } from './CustomElementDefinition';
import { getExportedComponents } from './WebComponentDecorator';

export abstract class WebComponentBootstrapModule implements DoBootstrap {
  public constructor();
  public constructor(exportedComponents: CustomElementDefinitions)
  public constructor(private readonly exportedComponents: CustomElementDefinitions = []) {}

  public ngDoBootstrap(appRef: ApplicationRef): void {
    for (const exportedComponent of this.exportedComponents) {
      this.defineComponent(appRef, exportedComponent);
    }

    for (const exportedComponent of getExportedComponents(this)) {
      this.defineComponent(appRef, exportedComponent);
    }
  }

  private defineComponent(appRef: ApplicationRef, component: CustomElementDefinition<unknown>): void {
    try {
      const customElement = createCustomElement(component.component, { injector: appRef.injector });
      customElements.define(component.tag, customElement);
    } catch (e) {
      console.error(e);
    }
  }
}
